import styled from 'styled-components';

export const ResourcesFilterBarBestOfYearWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 12px;

  padding: 20px 0px;
`;

export const ResourcesFilterBarBestOfYearSectionTitle = styled.h5`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourcesFilterBarBestOfYearItemIconContainer = styled.div`
  width: 45px;
  height: 45px;

  min-width: 45px;
  min-height: 45px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  border: 1px solid #000;
`;

export const ResourcesFilterBarBestOfYearItemIcon = styled.img`
  width: 45px;
  height: 45px;

  min-width: 45px;
  min-height: 45px;

  object-fit: cover;
`;

export const ResourcesFilterBarBestOfYearItemInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ResourcesFilterBarBestOfYearItemEntries = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourcesFilterBarBestOfYearItemTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  text-align: center;

  color: var(--color-text);
`;

interface ResourcesFilterBarBestOfYearItemContainerProps {
  current?: boolean;
}

export const ResourcesFilterBarBestOfYearItemContainer = styled.div<ResourcesFilterBarBestOfYearItemContainerProps>`
  width: 100%;
  min-height: 62px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8x;

  padding: 8px 24px 8px 22.5px;

  border-radius: 20px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 5px 0 20px -10px rgba(50, 63, 93, 0.1);

  cursor: pointer;

  ${({ current }) =>
    current &&
    `
    outline: 1px solid #000;
    background: radial-gradient(111.84% 97.93% at 10.92% 6.88%, rgba(255, 250, 250, 0.08) 0%, rgba(212, 212, 212, 0.01) 100%);
    box-shadow: 0 6px 24px 0 rgba(168, 144, 142, 0.40);
    backdrop-filter: blur(3px);

    ${ResourcesFilterBarBestOfYearItemIconContainer} {
      background: #000;
    }

    ${ResourcesFilterBarBestOfYearItemIcon} {
      filter: invert(1);
    }
  `}
`;
